import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { betStore, RoundStatus, userSettingsStore } from '@pascal/pascal-core';
import { FreeBetMaxPayoutPopUp } from '@pascal/pascal-core/bog-line/components/free-bets/freeBetMaxPayoutPopUp';

import { Timer } from '../../../components/timer';
import { doBetStore, gameStore } from '../../../store';
import { TutorialStepsPopUps } from '../tutorialStepsPopUps';
import { MaxWinPopUp } from '../../../components/maxWinPopUp';
import { useAnimationDelay } from '../../../hooks/useAnimationDelay';
import { fightersList, GameAnimationName } from '../../../enums/uiConfig';
import { BetAndCashOutCount } from '../betAndCashOutCount/BetAndCashOutCount';
import { JetScreenBottCornerBottom } from '../../../components/jetScreenBottCornerBottom';

export const Jets = observer(() => {
  const {
    time,
    oddData,
    isTabChange,
    currentJetsInfo,
    fightersBlowAnim,
    currentRoundStatus,
    updatedIsTabChange,
    initialPassedSecond,
    setCurrentRoundStatus,
    setInitialPassedSecond,
    currentRoundPassedSecond,
    setCurrentRoundPassedSecond,
  } = gameStore;

  const { isAnimationOn, setIsAnimationOn } = userSettingsStore;
  const { repliedBetData } = betStore;

  useEffect(() => {
    if (Number(time) === 4 && !initialPassedSecond && currentRoundStatus !== RoundStatus.Started) {
      setTimeout(() => setCurrentRoundStatus(RoundStatus.Started), 600);
    }

    if (time && time <= 3 && Number(time) >= 0 && !isAnimationOn) {
      if (currentRoundStatus !== RoundStatus.Started) {
        setCurrentRoundStatus(RoundStatus.Started);
      }
      setInitialPassedSecond(time * 1000);
    }
  }, [time, initialPassedSecond, isAnimationOn, currentRoundStatus]);

  useEffect(() => {
    if (repliedBetData && !isAnimationOn) {
      setIsAnimationOn();
    }

    if (isTabChange) {
      setCurrentRoundPassedSecond();
    }
  }, [repliedBetData, isAnimationOn, isTabChange]);

  const { calculatedAnimationDelay } = useAnimationDelay({
    gameAnimationDelay: currentRoundPassedSecond || initialPassedSecond,
    roundStatus: currentRoundStatus,
  });

  useEffect(() => {
    if (currentRoundStatus === RoundStatus.Started && isTabChange) {
      updatedIsTabChange(false);
    }
  }, [currentRoundStatus, isTabChange]);

  return (
    <div
      className={`fighters-game-section ${
        (currentRoundStatus && currentRoundStatus !== RoundStatus.OnFinish && isAnimationOn) ||
        (repliedBetData && !gameStore.isRoundFin)
          ? 'start'
          : ''
      } ${!isAnimationOn ? 'animation-off' : ''}`}
    >
      {time && <Timer time={time} />}
      <div className='fighters-game-section-left'>
        <div
          className='fighters-game-videos-block'
          onClick={() => {
            if (gameStore.oddData) {
              gameStore.setIsAnimationOffOn();
            }
            setIsAnimationOn();
          }}
        >
          {isAnimationOn ? <i className='ui-lib-Camera-on' /> : <i className='ui-lib-Camera-off' />}
        </div>
        <BetAndCashOutCount />
      </div>
      <JetScreenBottCornerBottom />
      <TutorialStepsPopUps />
      <MaxWinPopUp />
      <FreeBetMaxPayoutPopUp />
      <span className='moon-bg' style={calculatedAnimationDelay(GameAnimationName.Moon)} />
      <span className='animation-off-bg' />
      <span className='airplane-bg' style={calculatedAnimationDelay(GameAnimationName.Airplane)} />
      <span className='asteroid-bg' style={calculatedAnimationDelay(GameAnimationName.Asteroid)} />
      <div className='jets-planes'>
        {doBetStore.betData.map((item) => (
          <div
            key={item.fighterNumber}
            style={{
              ...calculatedAnimationDelay(GameAnimationName.JetPlane),
              visibility: fightersBlowAnim[item.fighterNumber] && isAnimationOn ? 'hidden' : '',
            }}
            className={`jet-plane ${item.finishedOdd && isAnimationOn ? 'blowup' : ''} 
             ${!isAnimationOn && item.finishedOdd ? 'disabled' : ''} ${
              item.winAmount ? 'cashout' : ''
            }`}
          >
            <div className='jet-plane-blowup-bg' />
            <span
              className='jet-plane-flames'
              style={calculatedAnimationDelay(GameAnimationName.JetsFlamesOrange)}
            >
              <span
                className='jet-plane-blue-flames'
                style={calculatedAnimationDelay(GameAnimationName.JetsFlamesBlue)}
              />
            </span>
            <span
              className='jet-plane-flames'
              style={calculatedAnimationDelay(GameAnimationName.JetsFlamesOrange)}
            >
              <span
                className='jet-plane-blue-flames'
                style={calculatedAnimationDelay(GameAnimationName.JetsFlamesBlue)}
              />
            </span>
            {(oddData && !item.finishedOdd && isAnimationOn) || (!isAnimationOn && oddData) ? (
              <div
                className={`jet-plane-odd-game type-${fightersList[item.fighterNumber].jetNumber}`}
              >
                <span className='jet-plane-odd-game-text'>{`x${
                  isAnimationOn ? currentJetsInfo[item.fighterNumber]?.toFixed(2) : item.finishedOdd
                }`}</span>
              </div>
            ) : (
              <></>
            )}
          </div>
        ))}
      </div>
      {isAnimationOn && (
        <div className='launch-pad-block'>
          <span
            className='fighters-launch-pad'
            style={calculatedAnimationDelay(GameAnimationName.LaunchPad)}
          />
          <span
            className='fighters-launch-pad'
            style={calculatedAnimationDelay(GameAnimationName.LaunchPad)}
          />
          <span
            className='fighters-launch-pad'
            style={calculatedAnimationDelay(GameAnimationName.LaunchPad)}
          />
        </div>
      )}
      <span className='smoke-block' style={calculatedAnimationDelay(GameAnimationName.SmokeBrake)}>
        <span className='smoke-fly' style={calculatedAnimationDelay(GameAnimationName.SmokeFly)} />
      </span>
      <div className='fighters-sky' style={calculatedAnimationDelay(GameAnimationName.FightersSky)}>
        <span className='sky-loop' style={calculatedAnimationDelay(GameAnimationName.SkyLoop)} />
      </div>
      <div className='jets-ground' style={calculatedAnimationDelay(GameAnimationName.JetsGround)}>
        <span
          className='jets-ground-inner'
          style={calculatedAnimationDelay(GameAnimationName.JetsGroundInner)}
        />
      </div>
      <div className='f-game-w-top-holder' />
    </div>
  );
});
